import axios from 'axios';
import config from 'config';

import { dispatcher } from 'lib/redux';
import { AUTH_ERROR, SESSION_AUTH_INVALID } from 'constants/actions';

import { E_AUTH_UNKNOWN } from 'constants/errors';

var instance = axios.create({
  baseURL: config.api.baseUrl + config.api.url,
  timeout: 60000,
  withCredentials: true
});

const dispatchAuthError = (error) => {
  try {
    var data = JSON.parse(error.request.responseText);
    dispatcher(AUTH_ERROR, data.error);
  } catch (e) {
    dispatcher(AUTH_ERROR, E_AUTH_UNKNOWN);
  }
};

instance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response.status === 401) {
      dispatcher(SESSION_AUTH_INVALID);
      dispatchAuthError(err);
      err.canceled = true;
    }

    return Promise.reject(err);
  }
);

export default instance;
